import { useCallback, useEffect, useRef, useState } from "react";
//Components
import { InfoBlock } from "../../../../components/infoBlock";
import {
  LuCircleDollarSign as TbCoinEuro,
  LuShoppingBag as LiaShoppingBasketSolid,
  LuTarget,
  LuTimer,
  LuDownload,
  LuUndo2 as FiRefreshCw,
} from "react-icons/lu";
import {
  HiMiniArrowTrendingUp,
  HiMiniArrowTrendingDown,
} from "react-icons/hi2";
import { OrdersList } from "./list";
import { Edition } from "./edition";
import { TableLayout } from "../../layouts/table";
import { getOrders, getStatisticsOrders } from "../../../../api/orders";
//Functions
//Styles
import "./style.css";

export const Orders = () => {
  const [period, setPeriod] = useState("30days");
  const exportView = useRef(null);
  const [canExport, setCanExport] = useState(false);
  const onExportView = useCallback((value) => {
    exportView.current = value;
    setCanExport(Boolean(value));
  }, []);
  const [dataStatistics, setDataStatistics] = useState(null);
  const [statisticsStatus, setStatisticsStatus] = useState("loading");
  const statisticsPending = useRef(false);
  const statisticsSequence = useRef(0);

  const getStatistics = useCallback(async () => {
    if (statisticsPending.current) return;
    const sequence = ++statisticsSequence.current;
    statisticsPending.current = true;
    setStatisticsStatus("loading");
    try {
      const response = await getStatisticsOrders({ timeFrame: period });
      if (sequence !== statisticsSequence.current) return;
      const statistics = response?.data?.statistics;
      if (
        !response ||
        response.error ||
        !statistics ||
        typeof statistics !== "object" ||
        Array.isArray(statistics)
      ) {
        setStatisticsStatus("error");
        return;
      }
      setDataStatistics(statistics);
      setStatisticsStatus("ready");
    } catch {
      if (sequence !== statisticsSequence.current) return;
      setStatisticsStatus("error");
    } finally {
      if (sequence === statisticsSequence.current)
        statisticsPending.current = false;
    }
  }, [period]);

  useEffect(() => {
    statisticsPending.current = false;
    getStatistics();
    return () => {
      statisticsSequence.current += 1;
    };
  }, [getStatistics]);

  const metric = (value, currency = false) => {
    if (
      value == null ||
      String(value).trim() === "" ||
      !Number.isFinite(Number(value))
    )
      return "—";
    return currency
      ? new Intl.NumberFormat("es-ES", {
          style: "currency",
          currency: "EUR",
        }).format(Number(value))
      : String(value);
  };
  const InfoBlocks = () => {
    if (statisticsStatus === "loading")
      return <div role="status">Cargando estadísticas…</div>;
    if (statisticsStatus === "error")
      return (
        <div>
          <p role="alert">
            No se han podido cargar las estadísticas. Puedes volver a
            intentarlo.
          </p>
          <button type="button" onClick={getStatistics}>
            Reintentar estadísticas
          </button>
        </div>
      );
    return (
      <>
        <InfoBlock
          icon={<LiaShoppingBasketSolid />}
          title={"Pedidos totales"}
          value={metric(dataStatistics.totalOrders)}
          graph={false}
          iconGraph={<HiMiniArrowTrendingUp />}
          valueGraph={"0%"}
        />
        <InfoBlock
          icon={<TbCoinEuro />}
          title={"Valor promedio"}
          value={metric(dataStatistics.averageOrderValue, true)}
          graph={false}
          iconGraph={<HiMiniArrowTrendingUp />}
          valueGraph={"0%"}
        />
        <InfoBlock
          icon={<FiRefreshCw />}
          title={"Devoluciones"}
          value={metric(dataStatistics.averageRefundValue, true)}
          graph={false}
          iconGraph={<HiMiniArrowTrendingDown />}
          valueGraph={"0%"}
          theme="infoDanger"
        />

        <InfoBlock
          icon={<LuTarget />}
          title="Tasa de conversión"
          value="—"
          graph={false}
        />
        <InfoBlock
          icon={<LuTimer />}
          title="Tiempo de preparación"
          value="—"
          graph={false}
        />
      </>
    );
  };

  return (
    <section className="ordersReference">
      <div className="topContainer">
        <div className="pageHeading">
          <h1 className="bodyTitle">Pedidos</h1>
        </div>
        <div className="ordersHeadingActions">
          <button
            type="button"
            disabled={!canExport}
            onClick={() => exportView.current?.()}
          >
            <LuDownload aria-hidden="true" /> Exportar
          </button>
          <label>
            <span className="visually-hidden">Periodo de pedidos</span>
            <select value={period} onChange={(e) => setPeriod(e.target.value)}>
              <option value="30days">Últimos 30 días</option>
              <option value="7days">Últimos 7 días</option>
              <option value="all">Todo el historial disponible</option>
            </select>
          </label>
        </div>
      </div>
      <div className="infoBlocksContainerOrders">
        <InfoBlocks />
      </div>
      <p className="ordersMetricScope">
        Resumen del periodo. Devoluciones: importe medio. Conversión,
        preparación y variaciones: datos no disponibles.
      </p>
      <TableLayout
        renderContent={(rows, open) => (
          <OrdersList
            rows={rows}
            open={open}
            period={period}
            onExportView={onExportView}
          />
        )}
        title=""
        addText=""
        edition={<Edition />}
        get={getOrders}
        remove={() => null}
        identificator={"ordersclient"}
      />
    </section>
  );
};
